import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { ItemsCreators } from '../../../store/actions/items';
import { BotsCreators } from '../../../store/actions/bots';
import { ConnectorsCreators } from '../../../store/actions/connectors';
import { itemIconDoubleClick } from '../utils';

import iconGroup from '../../../assets/images/icon_group.svg';
import iconGroupHover from '../../../assets/images/icon_group_hover.svg';

const GroupSettings = (props) => {
  const { botId, zoomLevel, item, debounceList, showRightMenu } = props;

  const [icon, setIcon] = useState(iconGroup);

  const onClickExpandGroupButton = () => {
    const action = itemIconDoubleClick[item.type];
    if (action) {
      const {
        changeCurrentFlow,
        getSubflowItems,
        getConnectorsSubflowRequest,
        saveBotViewPosition,
        groupTrigger,
      } = props;

      const options = {
        botId,
        zoomLevel,
        item,
        changeCurrentFlow,
        getSubflowItems,
        getConnectorsSubflowRequest,
        saveBotViewPosition,
        debounceList,
        groupTrigger,
      };
      action(options);
      showRightMenu(undefined, undefined);
    }
  };

  const onMouseEnterExpandGroupButton = () => {
    setIcon(iconGroupHover);
  };

  const onMouseLeaverExpandGroupButton = () => {
    setIcon(iconGroup);
  };

  return (
    <div>
      <button
        className="settings-conditional-button-create-condition"
        type="button"
        onClick={onClickExpandGroupButton}
        onMouseEnter={onMouseEnterExpandGroupButton}
        onMouseLeave={onMouseLeaverExpandGroupButton}
      >
        <img alt="Group" src={icon} />
        &nbsp;&nbsp;{'Expandir grupo'}
      </button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  items: state.items.list,
  currentFlow: state.items.currentFlow,
  debounceList: state.debounce.list,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...BotsCreators, ...ItemsCreators, ...ConnectorsCreators },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroupSettings)
);
